module.exports = __webpack_public_path__ + "img/add-property.7b46441f.png";